import React, { useEffect } from "react";
import DatagolEmbed from "./DatagolEmbed";

export default function DatagolRouter({ content, config, setError }) {
  useEffect(() => {
    if (!config?.provider) {
      setError("Provider type does not exist.");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config?.provider]);

  return <>{config?.type === "IFRAME_EMBED" && <DatagolEmbed content={content} />}</>;
}
